import {
  AffiliateRelationshipType,
  AffiliateRetirementType,
  AffiliateType,
  AffiliateHierarchy
} from '@/interfaces/affiliates';
import {
  Destination,
} from '@/interfaces/destination';
import {
  getAffiliateRelationshipTypes,
  getAffiliateRetirementTypes,
  getAffiliateTypes,
  getAffiliateHierarchies
} from '@/services/affiliates.service';
import {
  queryDestinations,
} from '@/services/destinations.service';
import { Effect, Reducer } from '@umijs/max';

export interface ModelType {
  namespace: string;
  state: {
    affiliateTypes: AffiliateType[];
    affiliateRetirementTypes: AffiliateRetirementType[];
    affiliateRelationshipTypes: AffiliateRelationshipType[];
    affiliateHierarchies: AffiliateHierarchy[];
    affiliateDestinations: Destination[];
  };
  effects: {
    fetchAffiliateTypes: Effect;
    fetchAffiliateHierarchies: Effect;
    fetchAffiliateDestinations: Effect;
  };
  reducers: {
    setAffiliateTypes: Reducer<any>;
    setAffiliateHierarchies: Reducer<any>;
    setAffiliateDestinations: Reducer<any>;
  };
}

const Model: ModelType = {
  namespace: 'affiliateList',

  state: {
    affiliateTypes: [],
    affiliateRelationshipTypes: [],
    affiliateRetirementTypes: [],
    affiliateHierarchies: [],
    affiliateDestinations: [],
  },

  effects: {
    *fetchAffiliateTypes({ payload }, { call, put, all }) {
      const [affiliateTypes, affiliateRetirementTypes, affiliateRelationshipTypes] = yield all([
        call(getAffiliateTypes, true),
        call(getAffiliateRetirementTypes, payload),
        call(getAffiliateRelationshipTypes, payload),
      ]);

      yield put({
        type: 'setAffiliateTypes',
        payload: {
          affiliateTypes: affiliateTypes,
          affiliateRetirementTypes: affiliateRetirementTypes.data,
          affiliateRelationshipTypes: affiliateRelationshipTypes.data,
        },
      });
    },

    *fetchAffiliateHierarchies({ payload }, { call, put, all }) {
        const [response] = yield all([
        call(getAffiliateHierarchies, payload)
      ]);

      yield put({
        type: 'setAffiliateHierarchies',
        payload: {
          affiliateHierarchies: response.data,
        },
      });
    },

    *fetchAffiliateDestinations({ payload }, { call, put, all }) {
      const [response] = yield all([
        call(queryDestinations, payload)
      ]);

      yield put({
        type: 'setAffiliateDestinations',
        payload: {
          affiliateDestinations: response.data,
        },
      });
    },
  },

  reducers: {
    setAffiliateTypes(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },

    setAffiliateHierarchies(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },

    setAffiliateDestinations(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};

export default Model;
